import React from 'react';

function beatLines(beats) {
  if (Array.isArray(beats)) return beats;
  // A fill phrase sometimes arrives as one string. Do not walk its letters.
  if (typeof beats === 'string' && beats !== '') return [beats];
  return [];
}

function beatPreview(beats) {
  const list = beatLines(beats);
  if (list.length === 0) return null;
  return `${list.length} moment${list.length === 1 ? '' : 's'}`;
}

/** What happens in this cell: the writer's note, else its beats in order. */
export function cellText(cell) {
  if (cell?.state === 'absent') return '';
  const note = String(cell?.note || '').trim();
  if (note) return note;
  return beatLines(cell?.beats).map((beat) => String(beat || '').trim()).filter(Boolean).join(' ');
}

/** One line per beat (the writer's note is one line), so a tall cell reads as a list. */
export function cellLines(cell) {
  if (cell?.state === 'absent') return [];
  const note = String(cell?.note || '').trim();
  if (note) return [note];
  return beatLines(cell?.beats).map((beat) => String(beat || '').trim()).filter(Boolean);
}

export default function PlotTrackCell({
  cell,
  row,
  column,
  selected,
  onSelect,
}) {
  const state = cell?.state || 'empty';
  const empty = state === 'empty';
  const absent = state === 'absent';
  const filled = !empty && !absent;
  const label = column?.display_name || 'Untitled scene';
  const rowLabel = row?.label || 'Row';

  return (
    <button
      type="button"
      className={`pt-cell pt-cell--${state}${selected ? ' pt-cell--selected' : ''}${filled ? ' pt-cell--filled' : ''}`}
      style={filled ? { '--pt-row-color': row?.color || '#888' } : undefined}
      onClick={() => onSelect && onSelect(row, column, cell)}
      aria-pressed={selected}
      aria-label={`${rowLabel} / ${label}: ${state}`}
    >
      {empty && <span className="pt-cell__add" aria-hidden="true">+</span>}
      {filled && state !== 'active' && <span className="pt-cell__state">{state}</span>}
      {filled && cellText(cell) && (
        <span className="pt-cell__text">
          {cellLines(cell).map((line, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <span key={index} className="pt-cell__line">{line}</span>
          ))}
        </span>
      )}
      {filled && beatPreview(cell.beats) && (
        <span className="pt-cell__beats">{beatPreview(cell.beats)}</span>
      )}
    </button>
  );
}
